module.exports = __webpack_public_path__ + "static/img/wechat.10c3a4c7.png";